import React, { useContext, useEffect, useState } from 'react'

import { Modal } from '@clientbase/clientbase-library'
import { NegativationService } from 'services/NegativationService'

import { NegativationContext } from '../context'
import DetailBody from './DetailBody'
import Skeleton from './Skeleton'

const Detail: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const { modalDetail, updateModalDetail, updateNegativation } =
    useContext(NegativationContext)
  const handleClose = () => {
    updateModalDetail({ open: false, uuid: '' })
  }

  const getDetails = async () => {
    try {
      setLoading(true)

      const response = await NegativationService.getNegativationDetails(
        modalDetail?.uuid
      )

      updateNegativation(response)
    } catch (err) {
      //
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (modalDetail?.open) {
      getDetails()
    }
  }, [modalDetail?.open, modalDetail?.uuid, modalDetail?.reloadKey])

  return (
    <Modal
      handleClose={handleClose}
      open={modalDetail?.open}
      maxWidth="1150px"
      width="100%"
      height="calc(100%-200px)"
      maxHeight="90vh"
      disablePortal
    >
      {loading ? <Skeleton /> : <DetailBody handleClose={handleClose} />}
    </Modal>
  )
}

export default Detail
